import { articleContents } from '../../../../mocks/article-contents';

interface ArticleContentProps {
  slug: string;
}

export default function ArticleContent({ slug }: ArticleContentProps) {
  const content = articleContents[slug];

  if (!content) {
    return (
      <div className="prose prose-lg max-w-none">
        <p className="text-gray-600">Content not available for this article.</p>
      </div>
    );
  }

  return (
    <div className="prose prose-lg max-w-none">
      <div className="text-gray-700 leading-relaxed space-y-6">
        {content.introduction && (
          <div className="text-xl text-gray-800 font-medium mb-8 leading-relaxed">
            {content.introduction}
          </div>
        )}

        {content.sections.map((section, index) => (
          <div key={index} className="mb-10">
            <h2 className="text-2xl font-bold text-[#1A1F2E] mb-4 mt-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              {section.heading}
            </h2>
            
            {section.content.map((paragraph, pIndex) => (
              <p key={pIndex} className="text-gray-700 mb-4 leading-relaxed">
                {paragraph}
              </p>
            ))}

            {section.list && (
              <ul className="list-disc list-inside space-y-2 ml-4 mb-6">
                {section.list.map((item, lIndex) => (
                  <li key={lIndex} className="text-gray-700">
                    <strong className="text-[#1A1F2E]">{item.title}:</strong> {item.description}
                  </li>
                ))}
              </ul>
            )}

            {section.tips && (
              <div className="bg-[#C9A961]/10 border-l-4 border-[#C9A961] p-6 rounded-r-lg my-6">
                <h3 className="text-lg font-bold text-[#1A1F2E] mb-3 flex items-center gap-2">
                  <i className="ri-lightbulb-line text-[#C9A961]"></i>
                  Pro Tips
                </h3>
                <ul className="space-y-2">
                  {section.tips.map((tip, tIndex) => (
                    <li key={tIndex} className="text-gray-700 flex items-start gap-2">
                      <i className="ri-check-line text-[#C9A961] mt-1"></i>
                      <span>{tip}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}

        {content.conclusion && (
          <div className="mt-12 p-8 bg-gradient-to-br from-[#1A1F2E] to-[#2A3F5E] rounded-2xl text-white">
            <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Final Thoughts
            </h2>
            <p className="text-gray-100 leading-relaxed mb-6">
              {content.conclusion}
            </p>
            <a
              href="/contact"
              className="inline-block px-6 py-3 bg-[#C9A961] text-white rounded-lg hover:bg-[#B89851] transition-colors whitespace-nowrap cursor-pointer"
            >
              Plan Your Journey With Us
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
